// extracted by mini-css-extract-plugin
var _1 = "modalPaymentStatus-module_button_bright__BUhuLv";
var _2 = "modalPaymentStatus-module_closeButton__exMZ8t";
var _3 = "modalPaymentStatus-module_dialogActions__kzGG2K";
var _4 = "modalPaymentStatus-module_dialogContnent__lMPREk";
var _5 = "modalPaymentStatus-module_head_title__U49pNl";
var _6 = "modalPaymentStatus-module_modalContainer__USRruC";
var _7 = "modalPaymentStatus-module_modalHeader__mNrIjq";
var _8 = "modalPaymentStatus-module_modalOverlay__mySgus";
var _9 = "modalPaymentStatus-module_modalTitle__RkqJFl";
export { _1 as "button_bright", _2 as "closeButton", _3 as "dialogActions", _4 as "dialogContnent", _5 as "head_title", _6 as "modalContainer", _7 as "modalHeader", _8 as "modalOverlay", _9 as "modalTitle" }
